// extracted by mini-css-extract-plugin
export default {"timerBadge":"TimerBadge_timerBadge__JXaQ5","timerIcon":"TimerBadge_timerIcon__4BBxP","timerText":"TimerBadge_timerText__8Lktg"};